import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {
  FlatButton,
  RefreshIndicator,
  CircularProgress,
  Card,
  Paper,
  FontIcon,
  Checkbox,
} from 'material-ui';
import RaisedButton from '../../tc-ui/raised-button-with-loader';
import Product from './product-mapping-product';
import SectionHeading from '../../tc-ui/section-heading';
import HistoryFeed from './export-history-feed.jsx';
import debounce from 'lodash.debounce';
import R from 'ramda';

const propTypes = {
  exportContract: PropTypes.func,
  history: PropTypes.object,
  user: PropTypes.object,
  contract: PropTypes.object,
  updateWithKeyPath: PropTypes.func,
  clearContract: PropTypes.func,
  sendMsg: PropTypes.func,
  getConvertedContract: PropTypes.func,
  displayExportPreview: PropTypes.bool,
  convertedContract: PropTypes.array,
  exportStatus: PropTypes.string,
  priceCodesSetting: PropTypes.object,
  saveSettings: PropTypes.func,
  ratePackageIds: PropTypes.array,
  checkAll: PropTypes.func,
  checkOnePackage: PropTypes.func,
  savingSettings: PropTypes.bool,
};

class productMapping extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  _sendContractnMapping = (contract) => {
    this.props.getConvertedContract(contract.contractId, this.props.ratePackageIds);
  };
  convertExportStatus = (exportStatus) => {
    return R.call(R.cond([
      [R.equals('exporting'), R.always('loading')],
      [R.equals('success'), R.always('hide')],
      [R.equals('failed'), R.always('ready')],
      [R.T, R.always('hide')],
    ]), exportStatus);
  };

  savePriceCodesSettings = (tourPlanOptionID) => debounce(newCodes => {
    const {
      saveSettings,
      priceCodesSetting,
    } = this.props;
    saveSettings({
      priceCodesSetting: {
        ...priceCodesSetting,
        productRulesObj: { ...priceCodesSetting.productRulesObj, [tourPlanOptionID]: newCodes },
      },
    });
  }, 500);

  checkOnePackage = (ratePackageId, hasRates) => (_, checked) => this.props.checkOnePackage({
    ratePackageId,
    hasRates,
    checked,
  });

  render() {
    const {
      contract,
      exportStatus,
      priceCodesSetting = {},
      ratePackageIds,
      checkAll,
      convertedContract,
      savingSettings,
    } = this.props;
    const { productRulesObj = {} } = priceCodesSetting;
    const { router } = this.context;
    if (!contract || R.isEmpty(contract)) return false;
    const spinner = this.convertExportStatus(exportStatus);
    const exportReady = Boolean(R.find(product => product.tourPlanOptionName, contract.products));
    const hasMerge = R.groupWith(
      (a, b) => a.tourPlanOptionID === b.tourPlanOptionID,
      contract.products.filter(o => ratePackageIds.indexOf(o._id) > -1),
    ).some(arr => arr.length > 1);
    const histories = (() => {
      if (!contract.locationLogs || contract.locationLogs.length === 0) {
        return (<div style={{ margin: '20px', textAlign: 'center' }}>No Export History</div>);
      }
      return (<div style={{ width: '75%', margin: '30px auto 40px', borderLeft: '2px solid #e8e8e8' }}>
          {
            contract.locationLogs.sort((a, b) => {
              if (a.timestamp < b.timestamp) return 1;
              if (a.timestamp > b.timestamp) return -1;
              return 0;
            })
             .map((log, index) => <HistoryFeed {...log} key={index}/>)
          }
        </div>);
    })();

    const hasRates = Boolean(R.find(R.propEq('hasRates', true), contract.products));
    return (
      <div style={{ marginTop: '16px' }}>
        {
          /*
           <SectionHeading
           title="Mapping & Export"
           subtitle={'Map products to Tourplan options, then export rates for those products into Tourplan'}
           style={{ whiteSpace: 'pre-wrap', marginBottom: '32px', width: '90%', marginLeft: '5%' }}
           />
           */
        }
        <Paper style={{ width: '100%', paddingBottom: '4px' }}>
          <div style={{ paddingLeft: '3%', height: '48px', borderBottom: '2px solid #f5f5f5', width: '100%' }} className="tc-table-sub-header flex-tc-sb">
            <div style={{ width: '32px' }}>
              <Checkbox
                checked={ratePackageIds.length === contract.products.filter(o => o.tourPlanOptionID).length}
                onCheck={checkAll}
              />
            </div>
            <div style={{ fontSize: '14px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: 'calc(50% - 282px)' }}>TourConnect Name</div>
            <div style={{ fontSize: '14px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '250px' }}>Tourplan Option ID</div>
            <div style={{ fontSize: '14px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: 'calc(50% - 420px)' }}>Tourplan Name</div>
            <div style={{ fontSize: '14px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '140px' }}>Rate Status</div>
            <div style={{ fontSize: '14px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '140px' }}>Export To</div>
            <div style={{ fontSize: '14px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '140px', paddingRight: '8px' }} className="flex-tc-sb">
              Tourplan Price Code
              {
                Boolean(savingSettings) && <CircularProgress size={30}/>
              }
            </div>
          </div>
          <div style={{ marginBottom: '24px' }}>
          {
            (contract.products || [])
            .map((product, index) => {
              return (<Product
                {...this.props}
                {...product}
                index={index}
                key={index}
                checked={ratePackageIds.indexOf(product._id) > -1}
                startDate={contract.startDate}
                endDate={contract.endDate}
                exportTo={product.exportTo || 'FIT & Group'}
                rateSetStatus={product.rateSetStatus || 'K'}
                checkOnePackage={this.checkOnePackage(product._id, product.hasRates)}
                priceCodes={productRulesObj[product.tourPlanOptionID]}
                savePriceCodesSettings={this.savePriceCodesSettings(product.tourPlanOptionID)}
              />);
            })
          }
          </div>
          </Paper>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <RaisedButton style={{ float: 'left', margin: '10px 0 15px' }} primary label="Back" onClick={() => router.push('/integration/contracts')} />
          <div className="flex-center" style={{ width: '30%', flexDirection: 'row-reverse' }}>
            {
              // Boolean(convertedContract && convertedContract.length) && (
              //   <RaisedButton
              //     style={{ marginLeft: '16px' }}
              //     secondary
              //     label="Next Step"
              //     onClick={() => updateWithKeyPath(['exportStep'], 2)}
              //   />
              // )
            }
            <div className="flex-center">
              {
               Boolean(convertedContract && convertedContract.length) ? (
                  <FlatButton
                    secondary
                    disabled={(!exportReady || spinner === 'loading' || !ratePackageIds.length || savingSettings)}
                    label="Re-Generate Export Preview"
                    onClick={this._sendContractnMapping.bind(this, contract)}
                  />) : (
                    <RaisedButton
                      disabled={(!exportReady || spinner === 'loading' || !ratePackageIds.length || savingSettings)}
                      secondary
                      label="Generate Export Preview"
                      onClick={this._sendContractnMapping.bind(this, contract)}
                    />
              )
              }
              <RefreshIndicator size={30} percentage={60} left={5} top={5} status={spinner} />
            </div>
          </div>
        </div>
        {
          hasRates && (
          <div style={{ display: 'flex', alignItems: 'center', textAlign: 'left', overflow: 'auto', marginLeft: '8%', marginTop: '10px', height: '64px' }}>
            <FontIcon className="tc-icon-warning2" color="grey" />
            <div style={{ display: 'inline-block', marginLeft: '8px' }}>
              {'Tourplan currently has rates for the option that this product has been mapped to. You can overwrite the rates in Tourplan by re-exporting or map this product to a new option.'}
            </div>
          </div>)
        }
        {
          hasMerge && (
          <div style={{ display: 'flex', alignItems: 'center', textAlign: 'left', overflow: 'auto', marginLeft: '4%', width: '92%', marginTop: '10px', height: '64px' }}>
            <FontIcon className="tc-icon-warning2" color="#ff4081" />
            <div style={{ display: 'inline-block', marginLeft: '8px' }}>
            You are attempting to export two TourConnect products into the same Tourplan Option. This feature should only be used to export both FIT and Group rates at the same time, using the same seasons and general settings for both products.
            </div>
          </div>)
        }
        {
          contract.products.some(prod => prod.hasPrivateTransfers) && (
          <div style={{ display: 'flex', alignItems: 'center', textAlign: 'left', overflow: 'auto', marginLeft: '4%', width: '92%', marginTop: '10px', height: '64px' }}>
            <FontIcon className="tc-icon-bulb" color="orange" />
            <div style={{ display: 'inline-block', marginLeft: '8px' }}>
            TourConnect’s ‘Up-to X Pax’ pricing is based on group pricing.  When importing these rates into your system, you can convert Up to X Pax to Group Pax Break pricing. For example, Up to 2 Pax = $200, Up to 5 Pax = $450, Up to 8 Pax = $560 can convert to 1-2 Pax = $100, 3-5 Pax = $450, 6-8 Pax = $560.
            </div>
          </div>)
        }
        <SectionHeading
          title="Export History"
          subtitle={`Contract Year ${(contract.contractYear || 'year').slice(4)}`}
          style={{ whiteSpace: 'pre-wrap', margin: '12px 0 32px' }}
        />

        <Card style={{ width: '100%', margin: '40px 0', padding: '24px 0' }}>
          {histories}
        </Card>
      </div>
      );
  }
}

productMapping.propTypes = propTypes;

const mapStateToProps = ({ integration }) => ({
  displayExportPreview: integration.get('displayExportPreview'),
  exportStatus: integration.get('exportStatus'),
  ratePackageIds: integration.get('ratePackageIds') ? integration.get('ratePackageIds').toJS() : [],
  contract: integration.get('contract') ? integration.get('contract').toJS() : {},
  convertedContract: integration.get('convertedContract') ? integration.get('convertedContract').toJS() : [],
  priceCodesSetting: integration.getIn(['settings', 'priceCodesSetting']) ? integration.getIn(['settings', 'priceCodesSetting']).toJS() : {},
  savingSettings: integration.getIn(['settings', 'savingSettings']),
});
const mapDispatchToProps = ({
  checkAll: (_, checked) => ({ type: 'CHECK_ALL_RATE_PACKAGE_FOR_TOURPLAN_EXPORT', payload: { checked } }),
  checkOnePackage: payload => ({ type: 'CHECK_A_RATE_PACKAGE_FOR_TOURPLAN_EXPORT', payload }),
});
productMapping.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(productMapping);



// WEBPACK FOOTER //
// ./src/app/components/integration/export/product-mapping.jsx